import type { Role } from '../../enums/Role';

export const canManageRecipesV2Bulk = (
  hasPermissionTo: (actions: Role[]) => boolean,
): boolean => hasPermissionTo(['RecipeV2BulkManage']);
